import { message } from "../../../helpers/utils";

export const createIslanderCodeOffer = (supportsIslanderCode) => ({
    allowSingleUse: true,
    supportsIslanderCode,
    schemeName: message('islandercodecheck')
})
